module.exports = __webpack_public_path__ + "static/media/phone.08a13e79.svg";